module.exports = __webpack_public_path__ + "media/images/application/template/logoslider/logo-persimmon-0db63d3c11afd98a9092281f34337f5f.png";